import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const AddToBatch = ({ show, handleClose, data }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add to Batch</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Add {data?.length || 0} orders to a batch (not implemented)</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddToBatch;